<script setup lang="ts">
import { TransitionPresets } from '@vueuse/core'

const { items } = defineProps<{
  items: StoryBlokTagItem[]
}>()

const emit = defineEmits(['onchange'])

const appConfig = useAppConfig()
const blog = appConfig.blog

const params = useUrlSearchParams('history')

const route = useRoute()
const queryTags = route.query?.tags as string

const state = reactive({
  selectedTags: queryTags?.split(',') || [] as string[],
  isMoreTagsOpen: false,
  showMoreTags: true,
})

function toggleSelectTag(tag: StoryBlokTagItem) {
  const index = state.selectedTags?.findIndex(x => x === tag.slug)
  if (index === -1)
    state.selectedTags.push(tag.slug)

  else
    state.selectedTags?.splice(index, 1)

  if (state.selectedTags.length > 0) {
    params.tags = state.selectedTags.toString()
    window.history.replaceState({}, '', `${route.path}?tags=${params.tags}`)
    emit('onchange', params.tags)
  }
  else {
    window.history.pushState({}, '', route.path)
    emit('onchange', '')
  }
}

const tagsRef = ref()
const baseNumber = ref(34)

function toggleMoreTags() {
  state.isMoreTagsOpen = !state.isMoreTagsOpen
}

const wrapperHeight = useTransition(baseNumber, {
  duration: 500,
  transition: TransitionPresets.easeInOutCubic,
})

watch(tagsRef, (newVal) => {
  state.showMoreTags = newVal.scrollHeight > 34
})

watch(() => state.isMoreTagsOpen, () => {
  baseNumber.value = state.isMoreTagsOpen ? tagsRef.value.scrollHeight : 34
})
</script>

<template>
  <div class="py-5 border-b border-background-secondary mb-5">
    <div
      ref="tagsRef"
      class="flex overflow-x-auto -mx-5 pl-5 md:flex-wrap md:overflow-hidden md:pl-0 md:-mx-0 gap-2.5"
      :class="!state.isMoreTagsOpen ? 'h-34px' : 'h-auto'"
      :style="{ height: wrapperHeight !== 100 ? `${wrapperHeight}px` : 'auto' }"
    >
      <div
        v-for="(tag, i) in items"
        :key="i"
        class="text-secondary-active flex-shrink-0 flex items-center text-sm bg-secondary-active bg-opacity-15 px-4 py-2 leading-18px rounded-lg cursor-pointer transition hover:bg-opacity-25 hover:text-hover"
        :class="{ 'bg-opacity-45 text-hover': state.selectedTags?.find(x => x === tag.slug) }"
        @click="toggleSelectTag(tag)"
      >
        #{{ tag.name }}
        <AppIcon v-if="state.selectedTags?.find(x => x === tag.slug)" class="ml-1" size="12" icon="far-times" />
      </div>
    </div>
    <div v-if="state.showMoreTags" class="justify-center mt-1.5 hidden md:flex">
      <div class="text-secondary-active hover:text-hover hover:underline-current hover:underline hover:underline-hover rounded-xl inline-flex justify-center items-center text-center duration-200 font-medium px-20px py-10px cursor-pointer" @click="toggleMoreTags">
        {{ blog.show }} {{ state.isMoreTagsOpen ? blog.less : blog.more }} {{ blog.topics }} ({{ items.length }})
        <span :class="{ 'transform rotate-180': state.isMoreTagsOpen }">
          <AppIcon size="17" icon="far-angle-down" />
        </span>
      </div>
    </div>
  </div>
</template>
